import React from "react";
import { Link } from "react-router-dom";

export const ArtistCard = ({ artists, role }) => {
  return (
    <div className="w-full mx-auto grid gap-3 sm:gap-4 grid-cols-1 xs:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6">
      {artists.map((artist) => (
        <div
          key={artist.id}
          className="w-full border border-border_color p-3 rounded-xl"
        >
          {/* Image */}
          <div className="w-full h-[192px]">
            <div className="relative h-[192px] rounded overflow-hidden block">
              <img
                alt={artist.name}
                className="object-cover object-center w-full h-full block rounded-xl"
                src={artist.image}
              />
            </div>
          </div>

          {/* Content */}
          <div className="mt-[6px]">
            <span className="font-bold text-[16px] text-[#262626] font-grotesk tracking-wide">
              {artist.name}
            </span>
            <p className="text-[#696565] text-sm font-grotesk font-medium line-clamp-2">
              {artist.userType}
            </p>

            <div className="flex items-center justify-center gap-2 w-full mt-2">
              <Link
                to={
                  artist.userType == "user"
                    ? `/${role}/user-profile/${artist.id}`
                    : `/${role}/artist-profile/${artist.id}`
                }
                className="w-full flex items-center justify-center text-[14px] font-bold border border-border_color font-grotesk text-primary py-3 px-5 rounded-[10px] whitespace-nowrap tracking-wide hover:text-white hover:bg-primary transition-all delay-75"
              >
                View Profile
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
